import { render, staticRenderFns } from "./ProjectActorDialogListTable.vue?vue&type=template&id=bf397a12&scoped=true&"
import script from "./ProjectActorDialogListTable.vue?vue&type=script&lang=js&"
export * from "./ProjectActorDialogListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActorDialogListTable.vue?vue&type=style&index=0&id=bf397a12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf397a12",
  null
  
)

export default component.exports